import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAppSidebar, LazyAppSidebarContent, LazyAppSidebarFooter, LazyAppSidebarGroup, LazyAppSidebarHeader, LazyBottomNavMobile, LazyBrandDisplay, LazyCPConfirmationModal, LazyCarousel, LazyDarkModeSwitcher, LazyDragDropZone, LazyFileAttachmentCard, LazyGlobalErrorPage, LazyGridLoadingIndicator, LazyNewFeatureBadge, LazyProfileCardMenuPanel, LazySelectableList, LazySelectableListRender, LazySidebarPopoverContent, LazySummaryCardMobile, LazySummaryCard, LazySummaryCardWeb, LazySwitcherSidebarMobile, LazySwitcherSidebar, LazyTopBarChatButton, LazyTopBarMobile, LazyAvatarBadgedAvatar, LazyAvatarShieldIcon, LazyCustomHamburgerMenuIcon, LazyExploreIcon, LazyStudioIcon, LazySpriteSymbol, LazySpriteSymbolInline } from '#components'
const lazyGlobalComponents = [
  ["AppSidebar", LazyAppSidebar],
["AppSidebarContent", LazyAppSidebarContent],
["AppSidebarFooter", LazyAppSidebarFooter],
["AppSidebarGroup", LazyAppSidebarGroup],
["AppSidebarHeader", LazyAppSidebarHeader],
["BottomNavMobile", LazyBottomNavMobile],
["BrandDisplay", LazyBrandDisplay],
["CPConfirmationModal", LazyCPConfirmationModal],
["Carousel", LazyCarousel],
["DarkModeSwitcher", LazyDarkModeSwitcher],
["DragDropZone", LazyDragDropZone],
["FileAttachmentCard", LazyFileAttachmentCard],
["GlobalErrorPage", LazyGlobalErrorPage],
["GridLoadingIndicator", LazyGridLoadingIndicator],
["NewFeatureBadge", LazyNewFeatureBadge],
["ProfileCardMenuPanel", LazyProfileCardMenuPanel],
["SelectableList", LazySelectableList],
["SelectableListRender", LazySelectableListRender],
["SidebarPopoverContent", LazySidebarPopoverContent],
["SummaryCardMobile", LazySummaryCardMobile],
["SummaryCard", LazySummaryCard],
["SummaryCardWeb", LazySummaryCardWeb],
["SwitcherSidebarMobile", LazySwitcherSidebarMobile],
["SwitcherSidebar", LazySwitcherSidebar],
["TopBarChatButton", LazyTopBarChatButton],
["TopBarMobile", LazyTopBarMobile],
["AvatarBadgedAvatar", LazyAvatarBadgedAvatar],
["AvatarShieldIcon", LazyAvatarShieldIcon],
["CustomHamburgerMenuIcon", LazyCustomHamburgerMenuIcon],
["ExploreIcon", LazyExploreIcon],
["StudioIcon", LazyStudioIcon],
["SpriteSymbol", LazySpriteSymbol],
["SpriteSymbolInline", LazySpriteSymbolInline],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
